import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'

//import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
import Switch from '@material-ui/core/Switch'

import { connect } from 'react-redux'

import { handleSavePhoto, handleDeletePhoto } from '../../actions/offices'
import t from '../../utils/lang/office'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: '300px',
    maxWidth: '800px',
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  }
});

class PhotoDialog extends Component {
  state = {
    photoId: null,
    descriptionPL: '',
    descriptionEN: '',
    mainPhoto: null
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props

    if (data.id !== prevProps.data.id) {
      //console.log('Data', data)

      this.setState(() => ({
        photoId: data.id ? data.id : null,
        descriptionPL: data.descriptionPL ? data.descriptionPL : '',
        descriptionEN: data.descriptionEN ? data.descriptionEN : '',
        mainPhoto: data.mainPhoto ? data.mainPhoto : null
      }))
    }
  }

  handleChangeDescriptionPL = e => {
    const descriptionPL = e.target.value

    this.setState(() => ({
      descriptionPL
    }))
  }

  handleChangeDescriptionEN = e => {
    const descriptionEN = e.target.value

    this.setState(() => ({
      descriptionEN
    }))
  }

  handleChangeMainPhoto = e => {
    const mainPhoto = e.target.checked

    this.setState(() => ({
      mainPhoto
    }))
  }

  handleSaveData = e => {
    const { officeId, handleClose, dispatch } = this.props
    const data = JSON.stringify(this.state)

    dispatch(handleSavePhoto(officeId, data))

    handleClose()
  }

  handleOnDeletePhoto = e => {
    const { officeId, handleClose, dispatch } = this.props
    const { photoId } = this.state

    dispatch(handleDeletePhoto(officeId, photoId))

    /*this.setState(() => ({
      photoId: null,
      descriptionPL: '',
      descriptionEN: '',
      mainPhoto: null
    }))*/

    handleClose()
  }

  render() {
    const { fullScreen, open, handleClose, classes } = this.props
    const { descriptionPL, descriptionEN, mainPhoto } = this.state

    const lang = 'en'

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Edit photo</DialogTitle>
          <DialogContent>
            <form className={classes.root}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="descriptionPL"
                  label={t[lang].photoDescriptionPL}
                  value={descriptionPL}
                  onChange={this.handleChangeDescriptionPL}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <TextField
                  id="descriptionEN"
                  label={t[lang].photoDescriptionEN}
                  value={descriptionEN}
                  onChange={this.handleChangeDescriptionEN}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={mainPhoto}
                      onChange={this.handleChangeMainPhoto}
                      value={t[lang].mainPhoto}
                      color={mainPhoto ? 'secondary' : 'default'}
                    />
                  }
                  label={t[lang].mainPhoto}
                />
              </FormControl>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleOnDeletePhoto} color="secondary">
              Delete
            </Button>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSaveData} color="primary" autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

PhotoDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  officeId: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
}

function mapStateToProps ({ authedUser }) {
  return {
    userId: authedUser.id
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withMobileDialog()(PhotoDialog)))


// WEBPACK FOOTER //
// ./src/components/Offices/PhotoDialog.js